import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { GqlError } from './GqlError';
import { AcceptInvitationInput, AcceptInvitationPayload } from './generated/types';

export const mutation = `mutation AcceptInvitation($input: AcceptInvitationInput! ) {
    acceptInvitation(input: $input) {
        orgId
    }
}`;

type Response = { acceptInvitation: AcceptInvitationPayload };
export interface AcceptInvitationResponseBody {
    data: Response;
    errors?: Array<GqlError>;
}

export const useAcceptInvitation = () => {
    const context = useContext(AppContext);

    return useMutation<Response, Array<GqlError>, AcceptInvitationInput>({
        mutationFn: async (input: AcceptInvitationInput) => {

            const result = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<AcceptInvitationResponseBody>);

            return result.data;
        },
    });
};